import PlaceholderView from './Placeholder';
import HeaderView from './Header';
import HomeView from './Home';
import LoginView from './Login';
import TippingMenuView from './Menu';
import Gamebar from "./Gamebar";
import TippingTipsLayout from './Tipping';
import TipsCollection from "./Tipping/TipsCollection";
import TipView from './Tipping/Tip';
import ActivateGameView from "./ActivateGame";
import FooterView from './Footer';
import WidgetBets from './Tipping/WidgetBets';
import StreakView from './Streak';
import OnboardingView from './Onboarding';
import TippingGlobalNotification from './TippingGlobalNotification';

import {
	PasswordChangeView,
	PasswordChangeConfirmationView,
} from './Password';

import {
	CompsCreateView,
	MyCompsTableView,
	CompCongratulationView,
	CompsJoinView,
	CompsJoinBar,
	JoinCompsFilterView,
	CompsSettingsView,
	CompInvitesView,
	CompRegenerationBarView,
	RegenerateCompTableView,
	RegenerationCompsHeaderView,
	RegenerationCompRestartView,
	RegenerationCompInviteView
} from './Comps';

import {
	AccountSettings,
	CommunicationsView,
} from './Account';

export * from './components';
export * from '../../../core/views';
export * from './RankingsTipping';
export * from './RankingsComp';
export * from './RankingsStreak';
export * from './Comps/Ladder';
export * from './Comps/ExtraMenu';
export * from './TippingCelebrityPopup';
export * from './Streak';
export * from './Tipping/TipFin';

export {
	MyCompsTableView,
	CompsCreateView,
	CompsSettingsView,
	CompInvitesView,
	CompRegenerationBarView,
	RegenerateCompTableView,
	RegenerationCompsHeaderView,
	RegenerationCompRestartView,
	RegenerationCompInviteView,
	WidgetBets,
	PlaceholderView,
	HeaderView,
	HomeView,
	LoginView,
	TippingMenuView,
	Gamebar,
	TippingTipsLayout,
	TipsCollection,
	TipView,
	ActivateGameView,
	CompCongratulationView,
	CompsJoinView,
	CompsJoinBar,
	JoinCompsFilterView,
	FooterView,
	AccountSettings,
	CommunicationsView,
	StreakView,
	OnboardingView,
	PasswordChangeView,
	PasswordChangeConfirmationView,
	TippingGlobalNotification
};

export default {
	PlaceholderView,
	CompsCreateView,
	HeaderView,
	HomeView,
	LoginView,
	TippingMenuView,
	TippingTipsLayout,
	Gamebar,
	TipsCollection,
	TipView,
	ActivateGameView,
	MyCompsTableView,
	CompCongratulationView,
	CompsJoinView,
	CompsJoinBar,
	JoinCompsFilterView,
	FooterView,
	AccountSettings,
	CommunicationsView,
	CompsSettingsView,
	CompInvitesView,
	CompRegenerationBarView,
	RegenerateCompTableView,
	RegenerationCompsHeaderView,
	RegenerationCompRestartView,
	RegenerationCompInviteView,
	WidgetBets,
	StreakView,
	OnboardingView,
	PasswordChangeView,
	PasswordChangeConfirmationView,
	TippingGlobalNotification
}